/* eslint-disable @nx/enforce-module-boundaries */
import { Component, Input, Inject } from '@angular/core';

import { NavigationItem } from '@cigna/chcp/shared/util';

import { ChcpFederationFacade } from '@cigna/chcp/shared/federation-data-access';

@Component({
  selector: 'cigna-nav-item',
  templateUrl: './nav-item.component.html',
  styleUrls: ['./nav-item.component.scss'],
})
export class NavItemComponent {
  private _navItem: NavigationItem;

  @Input()
  set navItem(value: NavigationItem) {
    this._navItem = value;
    if (value.path) {
      this.parsePath(value.path);
    }
  }
  get navItem(): NavigationItem {
    return this._navItem;
  }

  @Input() isTopLevel = false;
  @Input() dataTestAttribute: string;
  @Input() isImpersonator = false;
  @Input() hasChildren = false;

  @Input() hasWamApproval = false;
  @Input() isEnhInvUserFlow = false;
  @Input() hasChcpPatientReviews = false;

  routerLink: string;
  fragment: string;
  queryParams: Record<string, string> | null = null;

  constructor(private federationFacade: ChcpFederationFacade) {}

  private parsePath(path: string): void {
    try {
      const decodedPath = decodeURIComponent(path);

      // Split by fragment first
      const [pathWithQuery, fragmentPart] = decodedPath.split('#');
      this.fragment = fragmentPart || '';

      // Split by query params
      const [routePath, queryString] = pathWithQuery.split('?');
      this.routerLink = routePath;

      // Parse query params if they exist
      if (queryString) {
        const parsedParams: Record<string, string> = {};
        const params = queryString.split('&');
        params.forEach((param) => {
          const [key, value] = param.split('=');
          if (key) {
            parsedParams[key] = value ? decodeURIComponent(value) : '';
          }
        });
        this.queryParams = parsedParams;
      } else {
        this.queryParams = null;
      }
    } catch (e) {
      // Remove query params and fragment from path
      const cleanPath = path.split('?')[0].split('#')[0];
      this.routerLink = cleanPath;
      this.fragment = '';
      this.queryParams = null;
    }
  }

  getQueryParams(
    routerLink: string,
    title: string,
  ): Record<string, string> | null {
    if (routerLink === '/manage-access') {
      return { tab: title === 'Awaiting approval' ? 'awaiting' : 'all' };
    }
    return this.queryParams;
  }

  checkFederation() {
    this.federationFacade.saveBrighterFederationPartnerData();
  }
}
